import React from 'react';
/* eslint-disable */
export function Chat(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M16.9727 3.76172C17.0273 3.43359 16.8906 3.10547 16.6172 2.91406C16.3164 2.72266 15.9609 2.72266 15.6875 2.88672L3.4375 9.88672C3.13672 10.0508 2.97266 10.3516 3 10.6797C3 11.0352 3.21875 11.3086 3.51953 11.4453L6.33594 12.6211L14.3477 5.40234L8.41406 13.0312C8.30469 13.168 8.22266 13.3594 8.22266 13.5508V16.2031C8.22266 16.5039 8.49609 16.75 8.79688 16.75C8.98828 16.75 9.17969 16.668 9.28906 16.5039L10.6836 14.4258L14.0195 15.8203C14.1289 15.875 14.2383 15.875 14.3477 15.875C14.5117 15.875 14.6484 15.8477 14.7852 15.7656C15.0312 15.6562 15.1953 15.4102 15.2227 15.1367L16.9727 3.76172Z"
        fill="currentColor"
      />
    </svg>
  );
}
